import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/shows';

export default function CategoryNav() {
  const location = useLocation();

  return (
    <section className="px-4 md:px-6 py-8 md:py-10" aria-label="综艺分类导航">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex items-center gap-3 md:gap-4 overflow-x-auto scrollbar-hide pb-2">
          {categories.map(cat => (
            <Link
              key={cat.slug}
              to={cat.slug === 'all' ? '/' : `/category/${cat.slug}`}
              className={`flex-shrink-0 px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                (cat.slug === 'all' && location.pathname === '/') || location.pathname === `/category/${cat.slug}`
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-600 hover:bg-background-200'
              }`}
            >
              {cat.name}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}